import { ICredential, useListPaymentMethods } from '@givebacks/api/core';

export function useSelectHasEitherCardTypes() {
  return useListPaymentMethods((credentials: ICredential[]) =>
    credentials.some((credential) => !!credential?.enrolled)
  );
}
